import React, { useEffect } from "react";
import addIcon from "../../../assets/images/icons/add-icon.png";
import AllSinglePlanModel from "./AllSinglePlanModel";
import SinglePlanOverviewModal from "./SinglePlanOverviewModal";
import UploadJson from "../../../components/modals/UploadJson";

const AddSinglePlanButton = ({
                               setCurrentModal,
                               currentModal,
                               openModal,
                               modalAddBtn,
                               selectedPlanId,
                               handleFileUpload,
                               handleSubmit,
                               uploadedJson,
                               planData,
                               errorMessage,
                               fileName,
                               onAddNewPlanClick,
                               setUploadedJson,
                               handleImageUrlChange,
                               handleVideoUrlChange,
                               imageUrl,
                               videoUrl,
                             }) => {
  const closeModal = () => {
    setCurrentModal(null);
  };

  useEffect(() => {
    if (selectedPlanId) {
      openModal(2);
    }
  }, [selectedPlanId]);

  return (
    <div>
      <button
        className="btn btn-primary"
        onClick={() => {
          onAddNewPlanClick();
          openModal(1);
        }}
      >
        <img src={addIcon} alt="Add New Plan" />
        <span>{modalAddBtn}</span>
      </button>
      {currentModal === 1 && (
        <UploadJson
          onOpenModal2={() => openModal(2)}
          onClose={closeModal}
          onFileUpload={handleFileUpload}
          fileName={fileName}
          errorMessage={errorMessage}
        />
      )}
      {currentModal === 2 && (
        <SinglePlanOverviewModal
          jsonData={uploadedJson}
          onOpenModal={() => openModal(3)}
          onClose={closeModal}
          planData={planData}
          selectedPlanId={selectedPlanId}
          setUploadedJson={setUploadedJson}
          handleImageUrlChange={handleImageUrlChange}
          handleVideoUrlChange={handleVideoUrlChange}
          imageUrl={imageUrl}
          videoUrl={videoUrl}
        />
      )}
      {currentModal === 3 && (
        <AllSinglePlanModel
          jsonData={uploadedJson}
          onClose={closeModal}
          planData={planData}
          onSubmit={handleSubmit}
          selectedPlanId={selectedPlanId}
          setUploadedJson={setUploadedJson}
          handleImageUrlChange={handleImageUrlChange}
          handleVideoUrlChange={handleVideoUrlChange}
          imageUrl={imageUrl}
          videoUrl={videoUrl}
        />
      )}
    </div>
  );
};

export default AddSinglePlanButton;
